import React from "react";
import { FaMapMarkerAlt, FaPhone, FaEnvelope, FaClock } from "react-icons/fa";
import { init, send } from "@emailjs/browser";
import Swal from "sweetalert2";
import "./Contact.css";
import MapWithSidebar from "../components/common/MapWithSidebar";
import { useTranslation } from "react-i18next";

// 1. Inicializa EmailJS una vez al cargar este módulo
init(process.env.REACT_APP_EMAILJS_PUBLIC_KEY);

const Contacto = () => {
  const { t } = useTranslation();

  const [formData, setFormData] = React.useState({
    nombre: "",
    email: "",
    telefono: "",
    mensaje: "",
  });
  const [sending, setSending] = React.useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSending(true);

    const templateParams = {
      name: formData.nombre,
      email: formData.email,
      telefono: formData.telefono,
      message: formData.mensaje,
      time: new Date().toLocaleString(),
    };

    try {
      await send(
        process.env.REACT_APP_EMAILJS_SERVICE_ID,
        process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
        templateParams
      );

      Swal.fire({
        title: t("contactPage.alerts.success.title", "¡Mensaje enviado!"),
        text: t(
          "contactPage.alerts.success.text",
          "Tu mensaje se ha enviado con éxito."
        ),
        icon: "success",
        confirmButtonText: t("contactPage.alerts.success.confirm", "Aceptar"),
      });

      setFormData({ nombre: "", email: "", telefono: "", mensaje: "" });
    } catch (err) {
      console.error("EmailJS error:", err);
      Swal.fire({
        title: t("contactPage.alerts.error.title", "Error"),
        text: t(
          "contactPage.alerts.error.text",
          "Hubo un problema al enviar tu mensaje. Intenta nuevamente más tarde."
        ),
        icon: "error",
        confirmButtonText: t("contactPage.alerts.error.confirm", "Cerrar"),
      });
    } finally {
      setSending(false);
    }
  };

  return (
    <section className="contacto-section" id={t("contactPage.sectionId", "contacto")}>
      <div className="contacto-container">
        <h2 className="section-title">
          {t("contactPage.title", "Contáctanos")}
        </h2>
        <p className="section-subtitle">
          {t(
            "contactPage.subtitle",
            "Estamos aquí para ayudarte con tus proyectos"
          )}
        </p>

        <div className="contacto-grid">
          {/* Info de contacto */}
          <div className="contacto-info">
            <div className="info-item">
              <FaMapMarkerAlt className="info-icon" />
              <div>
                <h3>{t("contactPage.info.addressTitle", "Dirección")}</h3>
                <p>
                  {t(
                    "contactPage.info.addressText",
                    "100m norte y 50m este del Super Brayca, La Granja, Palmares."
                  )}
                </p>
              </div>
            </div>

            <div className="info-item">
              <FaPhone className="info-icon" />
              <div>
                <h3>{t("contactPage.info.phoneTitle", "Teléfono")}</h3>
                <p>+506 6168 6664</p>
              </div>
            </div>

            <div className="info-item">
              <FaEnvelope className="info-icon" />
              <div>
                <h3>{t("contactPage.info.emailTitle", "Email")}</h3>
                <p>rsantamaria@gruposantamaria.cr</p>
              </div>
            </div>

            <div className="info-item">
              <FaClock className="info-icon" />
              <div>
                <h3>{t("contactPage.info.scheduleTitle", "Horario")}</h3>
                <p>
                  {t(
                    "contactPage.info.hoursWeekdays",
                    "Lunes a Viernes: 7:00 am - 5:30 pm"
                  )}
                </p>
                <p>
                  {t(
                    "contactPage.info.hoursSaturday",
                    "Sábados: 8:00 am - 3:00 pm"
                  )}
                </p>
              </div>
            </div>
          </div>

          {/* Formulario */}
          <div className="contacto-form">
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <input
                  type="text"
                  name="nombre"
                  placeholder={t(
                    "contactPage.form.namePlaceholder",
                    "Nombre completo"
                  )}
                  value={formData.nombre}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="form-group">
                <input
                  type="email"
                  name="email"
                  placeholder={t(
                    "contactPage.form.emailPlaceholder",
                    "Correo electrónico"
                  )}
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="form-group">
                <input
                  type="tel"
                  name="telefono"
                  placeholder={t(
                    "contactPage.form.phonePlaceholder",
                    "Teléfono"
                  )}
                  value={formData.telefono}
                  onChange={handleChange}
                />
              </div>
              <div className="form-group">
                <textarea
                  name="mensaje"
                  placeholder={t(
                    "contactPage.form.messagePlaceholder",
                    "Tu mensaje o consulta"
                  )}
                  value={formData.mensaje}
                  onChange={handleChange}
                  required
                ></textarea>
              </div>
              <button type="submit" className="submit-btn" disabled={sending}>
                {sending
                  ? t("contactPage.form.submitSending", "Enviando…")
                  : t("contactPage.form.submitIdle", "Enviar mensaje")}
              </button>
            </form>
          </div>
        </div>

        {/* Mapa */}
        <div className="mapa-container">
          <MapWithSidebar />
        </div>
      </div>
    </section>
  );
};

export default Contacto;
